export const MAX_PRICE_LIMIT = 100000000;

const isInteger = (value: string) => {
  if (value === '') return true;
  return /^\d+$/.test(value);
};

export { isInteger };

// 判断当前路由是否支持双色模式
export const isDualColorPage = (url: string, dualColorRoutes: string[], locale: string) => {
  // 解析 URL，忽略查询参数和末尾斜杠
  const cleanPath = url.split('?')[0].replace(/\/$/, '');

  // 提取语言部分并移除
  const pathParts = cleanPath.split('/');
  const normalizedPath =
    pathParts[1] === locale
      ? `/${pathParts.slice(2).join('/')}` // 如果路径以 locale 开头，移除 locale
      : cleanPath; // 否则直接使用路径

  // 检查路径是否在支持的数组中
  return dualColorRoutes.includes(normalizedPath.replace(/^\//, ''));
};
